const featureFlags = {
  features: {
    agentEditPhoneNumber: () =>
      import.meta.env.VITE_FEATURE_FLAG_SETTING_AGENT_EDIT_PHONE_NUMBER ===
      'true',
    agentEditEmail: () =>
      import.meta.env.VITE_FEATURE_FLAG_SETTING_AGENT_EDIT_EMAIL === 'true',
    areTargetValidation: () =>
      import.meta.env.VITE_FEATURE_FLAG_SET_ARE_TARGET_VALIDATION === 'true',
    dashboardBanner: () =>
      import.meta.env.VITE_FEATURE_FLAG_DASHBOARD_BANNER === 'true',
    agentThisMonthTarget: () =>
      import.meta.env.VITE_FEATURE_FLAG_AGENT_THIS_MONTH_TARGET === 'true',
    leadsTrackerFilter: () =>
      import.meta.env.VITE_FEATURE_FLAG_LEADS_TRACKER_FILTER === 'true',
    leadsTrackerSurvey: () =>
      import.meta.env.VITE_FEATURE_FLAG_LEADS_TRACKER_SURVEY === 'true',
    bulkDeactivateAgent: () =>
      import.meta.env.VITE_FEATURE_FLAG_AGENT_MANAGEMENT_BULK_DEACTIVATE ===
      'true',
    termsUpdate: () =>
      import.meta.env.VITE_FEATURE_FLAG_TERMS_UPDATE === 'true',
    activityTracker: () =>
      import.meta.env.VITE_FEATURE_FLAG_ACTIVITY_TRACKER === 'true',
    createWeeklyMeetingMiddleware: () =>
      import.meta.env.VITE_FEATURE_FLAG_CREATE_WEEKLY_MEETING_MIDDLEWARE ===
      'true',
    agentManagementDetailDeactivateFlow: () =>
      import.meta.env
        .VITE_FEATURE_FLAG_AGENT_MANAGEMENT_DETAIL_DEACTIVATE_FLOW === 'true',
    agentManagementDetailReactivateFlow: () =>
      import.meta.env
        .VITE_FEATURE_FLAG_AGENT_MANAGEMENT_DETAIL_REACTIVATE_FLOW === 'true',
    oneOnOneBmSpv: () =>
      import.meta.env.VITE_FEATURE_FLAG_1ON1_BM_SPV === 'true',
  },
  routes: {
    weeklyMeeting: () =>
      import.meta.env.VITE_FEATURE_FLAG_MENU_WEEKLY_MEETING === 'true',
    agencyNewsPromoMaterial: () =>
      import.meta.env.VITE_FEATURE_FLAG_AGENCY_NEWS_PROMO_MATERIAL === 'true',
    agencyNewsLoyaltyProgram: () =>
      import.meta.env.VITE_FEATURE_FLAG_AGENCY_NEWS_LOYALTY_PROGRAM === 'true',
    agencyNewsTrainingMaterial: () =>
      import.meta.env.VITE_FEATURE_FLAG_AGENCY_NEWS_TRAINING_MATERIAL ===
      'true',
  },
};

export default featureFlags;
